import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  .show-beats,
  .hide-beats {
    margin-top: 2px !important;
    margin-bottom: 2px;
    font-weight: 500 !important;
    padding: 10px 8px !important;
    border-radius: 8px !important;
    cursor: pointer;
    color: var(--grey-1) !important;
    background-color: transparent !important;
    &:hover {
      background-color: var(--menu-color-hover) !important;
    }
  }

  .show-beats {
    margin-bottom: 4px !important;
    &:hover {
      background-color: var(--menu-color) !important;
    }
    body[data-theme-type="light"] & {
      &:hover {
        background-color: var(--menu-color-active) !important;
      }
    }
    &:hover {
      background-color: var(--menu-color) !important;
    }
  }

  .hide-beats {
    &:hover {
      background-color: var(--menu-color) !important;
    }
  }

  .check-beats-box {
    padding: 16px;
    font-weight: 500;
    margin: 16px 0;

    background-color: var(--container-color);
    border-radius: 16px;
    .beats-box {
      .tips {
        color: var(--grey-1);
      }

      p:not(.tips) {
        color: var(--grey-0);
      }

      h3 {
        margin: 0px;
        color: var(--grey-0);
      }
      border-radius: 8px;
      padding: 10px 16px;
      margin-bottom: 10px;
      border: 1.5px solid var(--divider);

      body[data-theme-type="light"] & {
        border: 1.5px solid var(--grey-3);
      }

      ol {
        padding-top: 10px;
        li {
          list-style-type: number;
          color: var(--grey-0);
          margin-left: 16px;
          padding-bottom: 10px;
        }
      }
    }
  }
`;
